export function phone (value: string) {
  const maskPhone = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/)
  return !maskPhone[2] ? maskPhone[1] : `(${maskPhone[1]}) ${maskPhone[2]}${maskPhone[3] ? `-${maskPhone[3]}` : ''}`
}
